@if (shouldShowIndicator() && !productionFlag()) {
<div class="environment-banner" [class]="'env-' + getEnvironmentColor()">
  <div class="banner-content">
    <span class="banner-text">Environment - {{ getEnvironmentLabel() }}</span>
  </div>
</div>
} 

